const SET_TICKET = 'SET_TICKET';
const UPDATE_TICKET = 'UPDATE_TICKET';
const GET_FILE_REQUEST = 'GET_FILE_REQUEST';
const GET_FILE_SUCCESS = 'GET_FILE_SUCCESS';
const GET_FILE_ERROR = 'GET_FILE_ERROR';
const POST_FILE_REQUEST = 'POST_FILE_REQUEST';
const POST_FILE_SUCCESS = 'POST_FILE_SUCCESS';
const POST_FILE_ERROR = 'POST_FILE_ERROR';
const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST';
const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
const DELETE_FILE_ERROR = 'DELETE_FILE_ERROR';


export const TICKET_MANAGEMENT_TYPES = {
    SET_TICKET,
    UPDATE_TICKET
};

export const TICKET_FILE_TYPES = {
    GET_FILE_REQUEST,
    GET_FILE_SUCCESS,
    GET_FILE_ERROR,
    POST_FILE_REQUEST,
    POST_FILE_SUCCESS,
    POST_FILE_ERROR,
    DELETE_FILE_REQUEST,
    DELETE_FILE_SUCCESS,
    DELETE_FILE_ERROR,
};